<!-- Disruptor Block -->
<ng-container *ngIf="newsticker">
  <hdi-section
    [paddingBlock]="false"
    [paddingTop]="true"
    [paddingBottom]="true"
  >
    <hdi-newsticker [caasData]="newsticker" [attr.data-preview-id]="newsticker.identifier"></hdi-newsticker>
  </hdi-section>
</ng-container>
<ng-container>
  <ng-container *ngIf="alert">
    <hdi-section [paddingBottom]="true" [paddingBlock]="false">
      <hdi-alert [caasData]="alert" [attr.data-preview-id]="alert.identifier"></hdi-alert>
    </hdi-section>
  </ng-container>

  <!-- Stage Block -->
  <ng-container *ngIf="stage">
    <hdi-section
      [paddingBlock]="alert || newsticker ? false : !paddingBlock"
      [paddingBottom]="alert || newsticker ? true : paddingBottom"
    >
      <hdi-home-stage
        [caasData]="stage"
        [imagesMetaData]="imagesMetaData"
        [attr.data-preview-id]="stage.identifier"
      ></hdi-home-stage>
    </hdi-section>
  </ng-container>

  <ng-container *ngIf="inpageNav && inpageMenu.length > 0">
    <hdi-inpage-navigation
      [caasData]="inpageNav"
      [CTAButton]="true"
      [inpageMenu]="inpageMenu"
    >
    </hdi-inpage-navigation>
  </ng-container>

  <ng-container *ngIf="newsComponent" [attr.data-preview-id]="newsComponent.identifier">
    <hdi-section>
      <hdi-filter-bar
        [news]="news"
        [caasFilters]="newsFilters"
        (filteredNews)="updateNews($event)"
      ></hdi-filter-bar>
    </hdi-section>
    <hdi-section [backgroundColor]="'grey'">
      <hdi-dynamic-teaser-showcase
        [news]="filteredNews.length > 0 ? filteredNews : news"
        [imagesMetaData]="imagesMetaData"
      ></hdi-dynamic-teaser-showcase>
    </hdi-section>
  </ng-container>

  <!-- Main Block -->
  <ng-container *ngIf="mainSections">
    <ng-container *ngFor="let section of mainSections; let i = index">
      <hdi-section
        [backgroundColor]="alternateBackground[i]"
        [mainSection]="section"
        [podcastData]="podcastData"
        [news]="news"
        [tags]="tags"
        [eventsData]="events"
        [newsFilters]="newsFilters"
        [imagesMetaData]="imagesMetaData"
        [id]="i.toString()"
      >
      </hdi-section>
    </ng-container>
  </ng-container>

  <!-- Video Modal -->
  <hdi-modal
    [showModal]="showModal"
    [type]="ModalType.VIDEO"
    [videoSrc]="videoSrc ?? ''"
    [videoId]="videoId ?? ''"
    [thumbnailSrc]="''"
    (closeModalTrigger)="showModal = $event"
  >
  </hdi-modal>
</ng-container>
